import React from 'react'
import classNames from 'classnames'

import ToolbarTooltip from './ToolbarTooltip'

export default React.memo(({ isActive, handleMouseDown, icon, slateObjectType, dataTestId }) => (
  <ToolbarTooltip slateObjectType={slateObjectType}>
    <div
      className={classNames('text-editor-toolbar-button', { active: isActive })}
      data-testid={dataTestId}
      onMouseDown={(event) => handleMouseDown(event, slateObjectType)}
    >
      {icon}
    </div>
  </ToolbarTooltip>
))
